import React from 'react'

import {
  buildFiveSegmentsData,
  type FiveSegmentsData,
} from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import { type Brand } from '~/hooks/useSurveyQuery'
import { type FiveSegmentCounts } from '~/utils'

import { useFiveSegmentsTotalData } from './useFiveSegmentsTotalData'

export const useGetFiveSegmentsData = (brand: Brand) => {
  const totalData = useFiveSegmentsTotalData(brand)

  return React.useCallback(
    (fiveSegmentCounts: FiveSegmentCounts, total: number): FiveSegmentsData =>
      buildFiveSegmentsData({
        fiveSegmentCounts,
        total,
        totalDataCounts: totalData.counts,
      }),
    [totalData.counts],
  )
}
